import React, { useState } from "react";
import dynamic from 'next/dynamic'
import styles from "../../styles/components/header.module.scss";
//import BurgerMenu from "../burgerMenu/index";
const BurgerMenu = dynamic(() => import("../burgerMenu/index"));
//import Icons from "../../public/assets/svg/index";
const Icons = dynamic(() => import("../../public/assets/svg/index"));
import _get from "lodash/get";
import router, { Router } from "next/router";
//import RequestDemoModal from "../Pages/RequestDemo";
const RequestDemoModal = dynamic(() => import("../Pages/RequestDemo"));
//import SubmitAnIdea from "../Pages/submitAnIdea";
const SubmitAnIdea = dynamic(() => import("../Pages/submitAnIdea"));
//import SuccessModal from "../../pages/successModal";
const SuccessModal = dynamic(() => import("../../pages/successModal"));
import * as Msal from "msal";
import endpoints from "../../utility/endpoints";
import { globalSearchResult } from "../../redux/globalSearch/actions";
import { useMediaQuery } from 'react-responsive';
import { useDispatch, connect } from "react-redux";
import { useWindowSize } from "react-use";
import Head from 'next/head'
import Loader from "../Loader"

function index(props) {
  console.log(" props of header ------", props);
//console.log(props.headerProps.header_component[0].field_header_logo[0].file_url)
  //const isTabletOrMobile = useMediaQuery({ query: '(max-width: 768px)' })

  const dispatch = useDispatch();
  const chatBotRef = React.useRef(null)
  const [nonrestrictedUser, setnonRestrictedUser] = React.useState([
    "admin",
    "internalUser",
    "gCad",
    'firstLevelGPMApprover',
    'GPMapprover',
    'firstGfcf',
    'gfcf'
  ]);

  const [ demandAccessUsers, setDemandAccessUsers ] = React.useState(["admin", "internalUser", "supportStatus" ])
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 500px)' })
  const [burgerMenuClick, setburgerMenuClick] = React.useState(false);
  const [adminButton, setadminButton] = React.useState(false);
  const [requestDemoModal, setRequestDemoModal] = React.useState(false);
  const [submitAnIdea, setSubmitAnIdea] = React.useState(false);
  const [successModal, setSuccessModal] = React.useState(false);
  const [authData, setAuthData] = React.useState(null);
  const [message, setMessage] = React.useState(
    "We received your request for demo. Please wait while team will try to get to you!"
  );
  const [sucessOrFailure, setsucessOrFailure] = React.useState(false);
  const [keyword, setKeyword] = React.useState("");
  const [mobileSearchActive, setMobileSearchActive] = React.useState(false)
  const profileDropdownRef = React.useRef(null)
  useOutsideAlerter(profileDropdownRef)

  // const [lastScroll, setLastScroll] = useState(0)

  const [sticky, setSticky] = React.useState(false);

  const { width } = useWindowSize();


  const stickyStyle = {
    transform: `translateY(${sticky ? "-100%" : "0"})`,
  };
  
  let lastScroll = 0;

  // React.useEffect(() => {
  //   if (width > 992) {
  //     document.addEventListener("scroll", trackScroll);
  //   }

  //   return () => {
  //     document.removeEventListener("scroll", trackScroll);
  //   };
  // }, []);
  
  const trackScroll = () => {
    if (window.scrollY >= lastScroll ) {
      setSticky(true)
    } else{
      setSticky(false)
    }

    lastScroll = window.scrollY;
  };

  React.useEffect(() => {
    try {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      //console.log('auth ----header', auth);
      setAuthData(auth);


      // window.addEventListener('message', function (e) {
      //   alert('heyy')
      //   var iframe = $("#atomFrame");
      //   var eventName = e.data[0];
      //   var data = e.data[1];
      //   switch (eventName) {
      //     case 'setHeight':
      //       iframe.height(data);
      //       break;
      //   }
      // }, false);

    } catch (e) {
     console.log("eroor", e);
    }
  }, []);



  React.useEffect(() => {

    if (props.videoClicked) {
      setSubmitAnIdea(true);
      props.setVideoClicked(false)
    }

  }, [props.videoClicked])

  // useEffect(()=> {

  //    var iframe = document.getElementById('chatBot');
  //       iframe.addEventListener('load', () => {
  //         alert("heyyy")
  //       console.log( iframe.contentWindow,"iframe infOOOOOOO" );
  //      })

  // })


  function useOutsideAlerter(ref) {
    React.useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setadminButton(false)
        }
      }

      // Bind the event listener
      document.addEventListener("click", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("click", handleClickOutside);
      };
    }, [ref]);
  }

  const burgerFunc = () => {
    let burger = !burgerMenuClick;
    setburgerMenuClick(!burgerMenuClick);
    if (burger === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  };
  const [loader, setloader] = useState(false);
  const goTo = (link) => {
    setloader(true);
    router.push(link);
    setTimeout(() => {
      setloader(false);
    }, 3000); 
    setadminButton(false)
  };

  const userLogout = async () => {
    try {
      // localStorage.clear();
      // router.push(props.pageRoutes.Logout);

      const msalConfig = {
        auth: {
          clientId: "e9eab7ce-f3e5-4b3b-9ecb-8dcbcc3f0bde",
          authority:
            "https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e",
          redirectUri: endpoints.redirectUriLogin,
          postLogoutRedirectUri: `${endpoints.redirectUriLogin}logout`,
        },
      };
      const msalInstance = new Msal.UserAgentApplication(msalConfig);

      let account = msalInstance.getAccount();

      msalInstance.logout();
    } catch (e) {
      // console.log("logout errpr", e);
    }
  };

  const handlerequestmodal = () => {
    let modal = !requestDemoModal;
    setRequestDemoModal(true);
    if (modal === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  };
  const handlesubmitIdea = () => {
    let ideamodal = !submitAnIdea;
    setSubmitAnIdea(true);
    if (!submitAnIdea === true) {
      document.body.style.overflow = "hidden";
    } else {
    //  alert("heyy")
      document.body.style.overflow = "unset";
    }
  };




  const handlelogo = () => {
    router.push("/");
  };
  const textInput = (e) => {
    setKeyword(e.target.value);
  };
  const submitSearch = (e) => {
    if (e.key === "Enter" && keyword != "") {
      dispatch(globalSearchResult(keyword));
    }
  };

  const searchClicked = () => {
    if (keyword != "") {
      dispatch(globalSearchResult(keyword));
    }
  }


  React.useEffect(() => {
    window.addEventListener("scroll", scrollToTop);
    window.addEventListener("message", (e) => {
      if (e.data.setHeight == 620 && isTabletOrMobile) {
        document.body.style.overflow = "hidden"
      }
      else {
        document.body.style.overflow = "unset"
      }
    })
    return () => window.removeEventListener("scroll", scrollToTop);
  
  }, []);

  const scrollToTop = () => {

    //console.log("scroll value", sc);
    try {
      let sc = window.pageYOffset;
      if (sc > 100) {
        document.getElementById("scrollToTop").style.display = "flex";
      } else {
        document.getElementById("scrollToTop").style.display = "none";
      }

    }
    catch (e) {
      //console.log(e)
    }

  }


  // useEffect(() => {
  //   window.addEventListener('message', function (e) {
  //     var iframe = document.getElementById("atomFrame");

  //     console.log(e.data, "e.data")
  //     console.log(iframe)
  //     var eventName = e.data[0];
  //     var data = e.data[1];
  //     switch (eventName) {
  //       case 'setHeight':
  //         if (data == 610){
  //        iframe.style.height = "600px"
  //        iframe.style.bottom = "-5rem" 
  //        iframe.style.overflow = "hidden"

  //       }
  //         else {
  //          iframe.style.height= "120px"
  //          iframe.style.zIndex = "9999"
  //          iframe.style.bottom = "-1rem" 
  //         }
  //         break;
  //     }
  //   }, false);


  //   return () => {
  //     window.removeEventListener("message", () => {return;})
  //   }
  // }, [])


  return (
    <>
      <Head>
        <script src="https://atombot.azurewebsites.net/public/scripts/frame-support.js"></script>
      </Head>
      {burgerMenuClick ? (
        <BurgerMenu
          data={props}
          authData={authData}
          userLogout={userLogout}
          setburgerMenuClick={setburgerMenuClick}
          handlesubmitIdea={handlesubmitIdea}
          handlerequestmodal={handlerequestmodal}
        />
      ) : null}
      <header className={styles.header} id="mainHeader">
        <div>
          <div className={styles.headWrapper}>
            <div className="container">
              <div className="row">
                <div className="col-4">
                  <div className={styles.logoMain}>
                    <div className={styles.logowrapper}>
                      <a href="/">
                        <img
                           src="https://automation.unilever.com/sites/default/files/2021-05/Unilever%20logo_header%20tab_1.svg"
                        //  src= {endpoints.drupalIp+_get(props, "headerProps.header_component[0].field_header_logo[0].file_url", "")}
                          onClick={() => {
                            handlelogo();
                          }}
                        />
                      </a>
                    </div>
                    <div className={styles.sublogowrapper}>
                      <a href="/">
                        <img 
                         src="https://automation.unilever.com/sites/default/files/2023-04/HAP_Logo_White_Transparent_BG_Horizontal_SVG.png"
                       // src= {endpoints.drupalIp+_get(props, "headerProps.header_component[0].field_header_logo[1].file_url", "")}
                         />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-8 d-flex justify-content-end">
                  <div className={styles.searchProfileWrapper}>
                    <div className={styles.search}>
                      <div className={styles.searchIcon} onClick={searchClicked}>
                        <Icons name="searchDesktop" />
                      </div>
                      {/* <input
                        name="keyword"
                        type="text"
                        placeholder="Search"
                        value={keyword}
                        onChange={(e) => {
                          textInput(e);
                        }}
                        onKeyPress={(e) => {
                          submitSearch(e);
                        }}
                      />*/}
                    </div>
                    {/*<div className={styles.ideaButton}>
                      <span
                        className={styles.actionBtn}
                        onClick={() => {
                          handlesubmitIdea();
                        }}
                      >
                        Submit an Idea
                      </span>
                    </div>*/}
                    {/*<div className={styles.demoButton}>
                      <span
                        className={styles.actionBtn}
                        onClick={() => {
                          handlerequestmodal();
                        }}
                      >
                        Request a Demo
              </span>
                    </div>*/}

                    <div
                      className={styles.profile}
                      onClick={() => {
                        setadminButton(!adminButton);
                      }}
                      ref={profileDropdownRef}
                    >
                      <Icons name="userDesktop" className={styles.userIcon} />
                    </div>
                  </div>
                  <div className={styles.searchMenuWrapper}>
                    {mobileSearchActive ?
                      <div className={styles.search}>
                        <div onClick={searchClicked} className={styles.searchIcon}>
                          <Icons name="searchDesktop" />
                        </div>
                        <input
                          name="keyword"
                          type="text"
                          placeholder="Search"
                          value={keyword}
                          onChange={(e) => {
                            textInput(e);
                          }}
                          onKeyPress={(e) => {
                            submitSearch(e);
                          }}
                        />
                        <div className={styles.crossIcon} onClick={() => setMobileSearchActive(false)}>
                          <Icons name="CrossIcon" />
                        </div>
                      </div> :
                      <>
                        <div className={styles.searchContain} onClick={() => setMobileSearchActive(true)}>
                          <Icons name="searchMobile" className={styles.searchMobileIcon} />
                        </div>
                        <div className={styles.burgerMenu} onClick={burgerFunc}>
                          {burgerMenuClick ? (
                            <Icons name="closewhite" className={styles.burgerMenuIcon} />
                          ) : (
                            <Icons name="burgerMenu" className={styles.burgerMenuIcon} />
                          )}
                        </div>
                      </>}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {adminButton ? (
            <div className="container">
              <div className={`${styles.adminLoginWrapper} row`}>
                <div className={`${styles.adminLogin}`}>
                  <ul>
                    <li
                      onClick={() => {
                        goTo("userProfile");
                      }}
                    >
                      {authData.name}
                    </li>
                     {authData.userType == "admin" ? (
                      <li
                        onClick={() => {
                          goTo("userAccessMapping");
                        }}
                      >
                        Admin Access Zone
                      </li>
                    ) : null} 
<li
                      onClick={() => {
                        goTo("Orderlisting");
                      }}
                    >
                      Order Listing
                    </li>                   
 <li onClick={userLogout} className={styles.logouticon}>
                      <Icons name="logout" className={styles.logi} />
                Logout
              </li>
                  </ul>
                </div>
              </div>
            </div>
          ) : null}
        </div>
        <nav className={`${styles.navbar} shadow-md`} style={stickyStyle}>
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-12">
              <div className={styles.left}>
               <ul>
                  {/* {_get(props, "headerProps", []).map((item, index) => (
                  <li
                    onClick={() => goToPage(item.field_link[0].uri) }
                    className={activeHome ? styles.active : null}
                  >
                    {item.field_title}
                  </li>
                ))} */}
                  <li
                    onClick={() => goTo("/")}
                    className={props.title == "Home" ? styles.active : null}
                  >
                    Home
              </li>
                  <li
                    onClick={() => goTo("/cez")}
                    className={
                      props.title == "Cognitive Experience Zone"
                        ? styles.active
                        : null
                    }
                  >
                     Experience Zone
              </li>
                  <li
                    onClick={() => goTo("/BotStore")}
                    className={props.title == "Bot Store" ? styles.active : null}
                  >
                    Bot Store
              </li>
{/*<li
                    className={props.title == "A.I." ? styles.active : null}
                  >
                   <a href='https://ui.ai.unilever.devstudioonline.com/' target={"_blank"}> A.I. </a>
              </li>*/}
                  <li
                    onClick={() => goTo("/Offerings")}
                    className={props.title == "Offerings" ? styles.active : null}
                  >
                    Offerings
              </li>


            {/*  <li
                      onClick={() => goTo("/decision-automation")}
                      className={
                        props.title == "decision-automation"
                          ? styles.active
                          : null
                      }
                    >
                      D.A.
                    </li> */}

              {/* <li
                    onClick={() => goTo("/Employeetwin")}
                    className={props.title == "employeetwin" ? styles.active : null}
                  >
                    Employee Twin
              </li> */}
              <li
                    onClick={() => goTo("https://automation.unilever.com/NewEmployeetwin")}
                    className={props.title == "New Employeetwin" ? styles.active : null}
                  >
                    Employee Twin
              </li>

 		<li
                    onClick={() => goTo("https://automation.unilever.com/products")}
                    className={props.title == "Product" ? styles.active : null}
                  >
                    Product
              </li>
              
         
   
           {/*   <li><a href="https://automationfactorychatgpt.azurewebsites.net/" target={"_blank"}>ChatGPT</a></li>*/}

                 {/*{demandAccessUsers.includes(props.userRole)  ? (
                    <>
                      <li
                        onClick={() => goTo("/Demand")}
                        className={props.title == "Demand" ? styles.active : null}
                      >
                        Demand
                  </li>
                    </>
                  ) : null}*/}
                   {props.userRole != "endUser"
                    ? <li
                      onClick={() => goTo("/Approvals")}
                      className={props.title == "Approvals" ? styles.active : null}
                    >
                      Approvals
              </li> : null}

                      {props.userRole === "admin" ||
                    props.userRole === "internalUser" ? (
                      <li
                        onClick={() => goTo("/hall-of-fame")}
                        className={
                          props.title == "H.O.F" ? styles.active : null
                        }
                      >
                        H.O.F
                      </li>
                    ) : null}


               

                  <li
                    onClick={() => goTo("/ContactUs")}
                    className={props.title == "Contact Us" ? styles.active : null}
                  >
                    Contact Us
              </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        </nav>
      </header>
        {loader ? <Loader /> : null} 
     {/* <div className={styles.chatBotOuter}  id="atomFrame"> */}
    {/* {(props.title == "Bot Store"||props.title == "Demand"||props.title == "Approvals")&& isTabletOrMobile ? null:  */}
      {/* <iframe src="https://bnlwe-da-q-57426-webapp-48.azurewebsites.net/public/atom.html" className={styles.chatBot} id="iframeAtom"></iframe> */}
        {/* a */}
      {/* </div> */}
      <a className={styles.scrollToTop} href="#headTop" id="scrollToTop">
        <Icons name="chevron" className={styles.chevron} />
      </a>
      {
        requestDemoModal ? (
          <RequestDemoModal
            data={props.requestDemoData.data.field_component}
            closeModal={() => {
              setRequestDemoModal(false);
            }}
            setSuccessModal={setSuccessModal}
            setMessage={setMessage}
            setsucessOrFailure={setsucessOrFailure}
          />
        ) : null
      }
      {
        submitAnIdea ? (
          <SubmitAnIdea
            closeModal={() => {
              setSubmitAnIdea(false);
              document.body.style.overflow = "unset";
            }}
	    getFormData={props.headerProps}
	  />
        ) : null
      }
      {
        successModal ? (
          <SuccessModal
            setSuccessModal={setSuccessModal}
            title={"Request a demo"}
            message={message}
            fail={sucessOrFailure}
          />
        ) : null
      }
    </>
  );
}
export default index;

